import { useEffect, useState } from "react";
import "./pager.css";

// Rows per page for admin lists (owner 28-10-2569: "เลือกแถวในการแสดงข้อมูลได้ เช่น 5, 10, 20, 30, 40, 50").
// The choice is remembered per list in this browser; the list goes back to page 1 when its filter changes.
export const PAGE_SIZES = [5, 10, 20, 30, 40, 50];

function readSize(key) {
  try {
    const n = Number(localStorage.getItem(key));
    return PAGE_SIZES.includes(n) ? n : 10;
  } catch {
    return 10;
  }
}

// rows = the filtered list; resetKey = anything that changes the filter (back to page 1)
export function usePaging(rows, storageKey, resetKey) {
  const [pageSize, setSize] = useState(() => readSize(storageKey));
  const [page, setPage] = useState(1);
  useEffect(() => { setPage(1); }, [resetKey, pageSize]);
  const pages = Math.max(1, Math.ceil(rows.length / pageSize));
  const current = Math.min(page, pages);
  const start = (current - 1) * pageSize;
  const setPageSize = (n) => {
    setSize(n);
    try { localStorage.setItem(storageKey, String(n)); } catch { /* storage blocked */ }
  };
  return { shown: rows.slice(start, start + pageSize), total: rows.length, start, pageSize, setPageSize, current, pages, setPage };
}

// "แสดง 1–10 จาก 24 รายการ" + the rows-per-page select
export function PageSummary({ paging, unit = "รายการ", note = "" }) {
  const { shown, total, start, pageSize, setPageSize } = paging;
  return (
    <div className="ed-pager">
      <span className="adm-note">
        {total ? `แสดง ${start + 1}–${start + shown.length} จาก ${total} ${unit}` : `แสดง 0 ${unit}`}
        {note}
      </span>
      <label className="ed-page-size">
        แถวต่อหน้า
        <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
          {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
    </div>
  );
}

// ← ก่อนหน้า · หน้า x / y · ถัดไป → (hidden on a single page)
export function PageNav({ paging }) {
  const { current, pages, setPage } = paging;
  if (pages <= 1) return null;
  return (
    <div className="ed-pager">
      <button type="button" className="button outline" disabled={current <= 1} onClick={() => setPage(current - 1)}>← ก่อนหน้า</button>
      <span>หน้า {current} / {pages}</span>
      <button type="button" className="button outline" disabled={current >= pages} onClick={() => setPage(current + 1)}>ถัดไป →</button>
    </div>
  );
}
